/**
 * PRISM's version and its history, shown in the app (the version under the
 * navigation opens it). Newest first. Each release lists what it added and
 * what it fixed, in the words people see in the app.
 */

// One file per release in ./releases/<version>.ts. `npm run release:bump` adds a new one after the markers.
// release-bump: imports
import r1_9_2 from './releases/1.9.2.ts';
import r1_9_1 from './releases/1.9.1.ts';
import r1_9_0 from './releases/1.9.0.ts';
import r1_8_3 from './releases/1.8.3.ts';
import r1_8_2 from './releases/1.8.2.ts';
import r1_8_1 from './releases/1.8.1.ts';
import r1_8_0 from './releases/1.8.0.ts';
import r1_7_4 from './releases/1.7.4.ts';
import r1_7_3 from './releases/1.7.3.ts';
import r1_7_2 from './releases/1.7.2.ts';
import r1_7_1 from './releases/1.7.1.ts';
import r1_7_0 from './releases/1.7.0.ts';
import r1_6_5 from './releases/1.6.5.ts';
import r1_6_4 from './releases/1.6.4.ts';
import r1_6_3 from './releases/1.6.3.ts';
import r1_6_2 from './releases/1.6.2.ts';
import r1_6_1 from './releases/1.6.1.ts';
import r1_6_0 from './releases/1.6.0.ts';
import r1_5_0 from './releases/1.5.0.ts';
import r1_4_0 from './releases/1.4.0.ts';
import r1_3_1 from './releases/1.3.1.ts';
import r1_3_0 from './releases/1.3.0.ts';
import r1_2_8 from './releases/1.2.8.ts';
import r1_2_7 from './releases/1.2.7.ts';
import r1_2_6 from './releases/1.2.6.ts';
import r1_2_5 from './releases/1.2.5.ts';
import r1_2_4 from './releases/1.2.4.ts';
import r1_2_3 from './releases/1.2.3.ts';
import r1_2_2 from './releases/1.2.2.ts';
import r1_2_1 from './releases/1.2.1.ts';
import r1_2_0 from './releases/1.2.0.ts';
import r1_1_0 from './releases/1.1.0.ts';
import r1_0_0 from './releases/1.0.0.ts';
import r1_0_0_rc_14 from './releases/1.0.0-rc.14.ts';
import r1_0_0_rc_13 from './releases/1.0.0-rc.13.ts';
import r1_0_0_rc_12 from './releases/1.0.0-rc.12.ts';
import r1_0_0_rc_11 from './releases/1.0.0-rc.11.ts';
import r1_0_0_rc_10 from './releases/1.0.0-rc.10.ts';
import r1_0_0_rc_9 from './releases/1.0.0-rc.9.ts';
import r1_0_0_rc_8 from './releases/1.0.0-rc.8.ts';
import r1_0_0_rc_7 from './releases/1.0.0-rc.7.ts';
import r1_0_0_rc_6 from './releases/1.0.0-rc.6.ts';
import r1_0_0_rc_5 from './releases/1.0.0-rc.5.ts';
import r1_0_0_rc_4 from './releases/1.0.0-rc.4.ts';
import r1_0_0_rc_3 from './releases/1.0.0-rc.3.ts';
import r1_0_0_rc_2 from './releases/1.0.0-rc.2.ts';
import r1_0_0_rc_1 from './releases/1.0.0-rc.1.ts';
import r0_99_1 from './releases/0.99.1.ts';
import r0_99_0 from './releases/0.99.0.ts';
import r0_98_0 from './releases/0.98.0.ts';
import r0_97_1 from './releases/0.97.1.ts';
import r0_97_0 from './releases/0.97.0.ts';
import r0_96_0 from './releases/0.96.0.ts';
import r0_95_0 from './releases/0.95.0.ts';
import r0_94_1 from './releases/0.94.1.ts';
import r0_94_0 from './releases/0.94.0.ts';
import r0_93_2 from './releases/0.93.2.ts';
import r0_93_1 from './releases/0.93.1.ts';
import r0_93_0 from './releases/0.93.0.ts';
import r0_92_0 from './releases/0.92.0.ts';
import r0_91_0 from './releases/0.91.0.ts';
import r0_90_1 from './releases/0.90.1.ts';
import r0_90_0 from './releases/0.90.0.ts';
import r0_31_0 from './releases/0.31.0.ts';
import r0_30_0 from './releases/0.30.0.ts';
import r0_29_0 from './releases/0.29.0.ts';
import r0_28_0 from './releases/0.28.0.ts';
import r0_27_0 from './releases/0.27.0.ts';
import r0_26_0 from './releases/0.26.0.ts';
import r0_25_0 from './releases/0.25.0.ts';
import r0_24_1 from './releases/0.24.1.ts';
import r0_24_0 from './releases/0.24.0.ts';
import r0_23_0 from './releases/0.23.0.ts';
import r0_22_2 from './releases/0.22.2.ts';
import r0_22_1 from './releases/0.22.1.ts';
import r0_22_0 from './releases/0.22.0.ts';
import r0_21_0 from './releases/0.21.0.ts';
import r0_20_2 from './releases/0.20.2.ts';
import r0_20_1 from './releases/0.20.1.ts';
import r0_20_0 from './releases/0.20.0.ts';
import r0_19_0 from './releases/0.19.0.ts';
import r0_18_6 from './releases/0.18.6.ts';
import r0_18_5 from './releases/0.18.5.ts';
import r0_18_4 from './releases/0.18.4.ts';
import r0_18_3 from './releases/0.18.3.ts';
import r0_18_2 from './releases/0.18.2.ts';
import r0_18_1 from './releases/0.18.1.ts';
import r0_18_0 from './releases/0.18.0.ts';
import r0_17_5 from './releases/0.17.5.ts';
import r0_17_4 from './releases/0.17.4.ts';
import r0_17_3 from './releases/0.17.3.ts';
import r0_17_2 from './releases/0.17.2.ts';
import r0_17_1 from './releases/0.17.1.ts';
import r0_17_0 from './releases/0.17.0.ts';
import r0_16_0 from './releases/0.16.0.ts';
import r0_15_1 from './releases/0.15.1.ts';
import r0_15_0 from './releases/0.15.0.ts';
import r0_14_1 from './releases/0.14.1.ts';
import r0_14_0 from './releases/0.14.0.ts';
import r0_13_0 from './releases/0.13.0.ts';
import r0_12_0 from './releases/0.12.0.ts';
import r0_11_0 from './releases/0.11.0.ts';
import r0_10_0 from './releases/0.10.0.ts';
import r0_9_4 from './releases/0.9.4.ts';
import r0_9_3 from './releases/0.9.3.ts';
import r0_9_2 from './releases/0.9.2.ts';
import r0_9_0 from './releases/0.9.0.ts';
import r0_8_0 from './releases/0.8.0.ts';
import r0_7_0 from './releases/0.7.0.ts';
import r0_6_0 from './releases/0.6.0.ts';
import r0_5_0 from './releases/0.5.0.ts';
import r0_4_0 from './releases/0.4.0.ts';
import r0_3_0 from './releases/0.3.0.ts';
import r0_2_0 from './releases/0.2.0.ts';
import r0_1_0 from './releases/0.1.0.ts';

export interface Release {
  version: string;
  date: string;
  title: string;
  features: string[];
  fixes: string[];
  /** What an administrator does before upgrading to this release (1.0.0-rc.12), shown first, in a box of its own. */
  beforeUpgrade?: string[];
  /**
   * The release in brief: 1–6 bullets (as few as the release needs, each thing said once), each at
   * most 20 words, in the words people see in the app. Features first, then fixes as "Fixed: …". No environment variable names, file paths or
   * error codes; those stay in the details (`features`, `fixes`, `beforeUpgrade`). Checked by
   * `summaryProblems`.
   */
  summary: string[];
  /** At most 3 short bullets for administrators, derived from `beforeUpgrade`. */
  upgradeSummary?: string[];
  /** The anchor of the release's "Upgrading to …" section in docs/deployment.md, e.g. `upgrading-to-100-rc13`. */
  upgradeGuide?: string;
}

export const SUMMARY_MIN_BULLETS = 1;
export const SUMMARY_MAX_BULLETS = 6;
export const SUMMARY_MAX_WORDS = 20;
export const UPGRADE_SUMMARY_MAX_BULLETS = 3;

/**
 * What breaks the summary rules for one release, in plain words; empty when it follows them.
 */
export function summaryProblems(release: Release): string[] {
  const problems: string[] = [];
  const v = release.version;
  const checkBullets = (field: 'summary' | 'upgradeSummary', bullets: string[]) => {
    bullets.forEach((b, i) => {
      const where = `${v} ${field}[${i}]`;
      const words = b.trim().split(/\s+/).filter(Boolean).length;
      if (words === 0) problems.push(`${where} is empty`);
      if (words > SUMMARY_MAX_WORDS) problems.push(`${where} has ${words} words (at most ${SUMMARY_MAX_WORDS})`);
      if (/PRISM_/.test(b)) problems.push(`${where} names a PRISM_ variable`);
      if (/(^|[\s(`'"])\.{0,2}\/[\w.-]+\/[\w./-]*/.test(b) || /(^|[\s(`'"])[\w.-]+\/[\w.-]+\.\w+\b/.test(b)) problems.push(`${where} has a file path`);
      if (/\b[\w-]+\.(ts|tsx|sh)\b/.test(b)) problems.push(`${where} names a source or script file`);
    });
  };
  if (release.summary !== undefined) {
    const n = release.summary.length;
    if (n < SUMMARY_MIN_BULLETS || n > SUMMARY_MAX_BULLETS) problems.push(`${v} summary has ${n} bullets (${SUMMARY_MIN_BULLETS}–${SUMMARY_MAX_BULLETS})`);
    checkBullets('summary', release.summary);
  }
  if (release.upgradeSummary !== undefined) {
    if (release.upgradeSummary.length > UPGRADE_SUMMARY_MAX_BULLETS) problems.push(`${v} upgradeSummary has ${release.upgradeSummary.length} bullets (at most ${UPGRADE_SUMMARY_MAX_BULLETS})`);
    checkBullets('upgradeSummary', release.upgradeSummary);
  }
  if (release.upgradeGuide !== undefined && !/^upgrading-to-[a-z0-9]+(-[a-z0-9]+)*$/.test(release.upgradeGuide)) {
    problems.push(`${v} upgradeGuide "${release.upgradeGuide}" is not an "upgrading-to-…" anchor`);
  }
  return problems;
}

export const RELEASES: Release[] = [
  // release-bump: list
  r1_9_2,
  r1_9_1,
  r1_9_0,
  r1_8_3,
  r1_8_2,
  r1_8_1,
  r1_8_0,
  r1_7_4,
  r1_7_3,
  r1_7_2,
  r1_7_1,
  r1_7_0,
  r1_6_5,
  r1_6_4,
  r1_6_3,
  r1_6_2,
  r1_6_1,
  r1_6_0,
  r1_5_0,
  r1_4_0,
  r1_3_1,
  r1_3_0,
  r1_2_8,
  r1_2_7,
  r1_2_6,
  r1_2_5,
  r1_2_4,
  r1_2_3,
  r1_2_2,
  r1_2_1,
  r1_2_0,
  r1_1_0,
  r1_0_0,
  r1_0_0_rc_14,
  r1_0_0_rc_13,
  r1_0_0_rc_12,
  r1_0_0_rc_11,
  r1_0_0_rc_10,
  r1_0_0_rc_9,
  r1_0_0_rc_8,
  r1_0_0_rc_7,
  r1_0_0_rc_6,
  r1_0_0_rc_5,
  r1_0_0_rc_4,
  r1_0_0_rc_3,
  r1_0_0_rc_2,
  r1_0_0_rc_1,
  r0_99_1,
  r0_99_0,
  r0_98_0,
  r0_97_1,
  r0_97_0,
  r0_96_0,
  r0_95_0,
  r0_94_1,
  r0_94_0,
  r0_93_2,
  r0_93_1,
  r0_93_0,
  r0_92_0,
  r0_91_0,
  r0_90_1,
  r0_90_0,
  r0_31_0,
  r0_30_0,
  r0_29_0,
  r0_28_0,
  r0_27_0,
  r0_26_0,
  r0_25_0,
  r0_24_1,
  r0_24_0,
  r0_23_0,
  r0_22_2,
  r0_22_1,
  r0_22_0,
  r0_21_0,
  r0_20_2,
  r0_20_1,
  r0_20_0,
  r0_19_0,
  r0_18_6,
  r0_18_5,
  r0_18_4,
  r0_18_3,
  r0_18_2,
  r0_18_1,
  r0_18_0,
  r0_17_5,
  r0_17_4,
  r0_17_3,
  r0_17_2,
  r0_17_1,
  r0_17_0,
  r0_16_0,
  r0_15_1,
  r0_15_0,
  r0_14_1,
  r0_14_0,
  r0_13_0,
  r0_12_0,
  r0_11_0,
  r0_10_0,
  r0_9_4,
  r0_9_3,
  r0_9_2,
  r0_9_0,
  r0_8_0,
  r0_7_0,
  r0_6_0,
  r0_5_0,
  r0_4_0,
  r0_3_0,
  r0_2_0,
  r0_1_0,
];

export const PRISM_VERSION = RELEASES[0]!.version;
